module.exports = __webpack_public_path__ + "static/media/Hippolyta.fd8b4c30.jpg";